/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Data Transfer Object for Token. This class is used to transfer token data between layers of the application. It inherits from TokenModel to ensure that it contains all necessary fields.
 */
export interface TokenDTO { 
    /**
     * Type of the token, usually \'bearer\'
     */
    token_type?: string;
    /**
     * The access token issued by the authorization server
     */
    access_token: string;
    /**
     * The lifetime in seconds of the access token
     */
    expires_in: number;
}

